import { createContext, useContext } from "react"

/** When true, weekly-training UserService calls use `REACT_APP_ECARDS_VIVINT_BASE_URL`. */
export const WeeklyTrainingEcardsContext = createContext(false)

export function useWeeklyTrainingEcardsApi() {
  return useContext(WeeklyTrainingEcardsContext)
}
